module.exports = __webpack_public_path__ + "img/rec-20.82cf66a9.png";